import styled, { css, DefaultTheme } from 'styled-components';

const Font = css`
  font-family: 'Mulish', sans-serif;
  font-weight: 400;
  font-style: normal;
`;

const getContainerColor = (theme: DefaultTheme, hasError: boolean, disabled: boolean) => {
  if (disabled) return theme.grayCC;
  if (hasError) return theme.status.error.default;
  return theme.gray4D;
};

export const HiddenInput = styled.input<{}>`
  display: none !important;
`;

export const FolderContainer = styled.div<{
  disabled?: boolean;
}>`
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  & > * {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  }
`;

export const DragContainer = styled.div<{ hasError: boolean; disabled: boolean }>`
  align-items: center;
  border: 2px dashed
    ${({ theme, hasError, disabled }) => getContainerColor(theme, hasError, disabled)};
  border-radius: 10px;
  color: ${({ theme, hasError, disabled }) => getContainerColor(theme, hasError, disabled)};
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: 700;
  gap: 16px;
  min-height: 200px;
  padding: 20px 16px;
  justify-content: center;
  width: 100%;
  margin-bottom: 12px;
`;

export const DragText = styled.p<{ truncateSingleLine?: boolean }>`
  margin: 0;
  max-width: min(520px, 90%);
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.35;
  ${({ truncateSingleLine }) =>
    truncateSingleLine &&
    css`
      display: inline-flex;
      align-items: baseline;
      justify-content: center;
      gap: 0;
      white-space: nowrap;
      overflow: hidden;
      word-break: normal;
      overflow-wrap: normal;
    `}
`;

export const DragTextBaseName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DragTextExtension = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
`;

export const ImageSourceSelectorContainer = styled.div<{ isOpen: boolean }>`
  max-height: 100vh;
  width: 100vw;
  position: fixed;
  background: rgba(45, 45, 45, 0.3);
  backdrop-filter: blur(2.5px);
  z-index: ${({ theme }) => theme.layers.topLayer};
  bottom: 0;
  left: 0;
  height: 100vh;
  transition: all ease 0.1s;
  visibility: visible;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      visibility: hidden;
    `}
`;

export const ImageSourceSelector = styled.div<{ isOpen: boolean }>`
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
  max-height: 168px;
  transition: all ease 0.35s;
  z-index: ${({ theme }) => theme.layers.topLayer};

  ${({ isOpen }) =>
    !isOpen &&
    css`
      max-height: 0;
    `}
`;

export const ImageSourceSelectorItem = styled.div`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 16px;
  border-bottom: 1px solid #ccc;
  &:active {
    background-color: #ccc;
  }
`;

export const DragErrorMessage = styled.div<{ disabled?: boolean }>`
  ${Font}
  ${({ theme, disabled }) => css`
    color: ${disabled ? theme.grayCC : theme.status.error.default};
    line-height: ${theme.input.error.lineHeight}px;
    font-size: ${theme.input.error.fontSize}px;
  `};
`;
